angular.module('common.filter.commoditycode', ['common.helper'])
    .filter('commodityCode', function (CommonHelper) {
        return function(commodityCode){
            if (!commodityCode || isNaN(CommonHelper.removeSpaceCharacters(commodityCode))){
                return commodityCode;
            }
            commodityCode = CommonHelper.removeSpaceCharacters(commodityCode);
            /*
                Pls see:
                https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
                page concerning regular expression:
                \B
                x(?=y)
                x(?!y)
                usage in below code.
             */
            if (commodityCode.length === 10) {
                return isNaN(commodityCode)?"":commodityCode.toString().replace(/\B(?=(\d{6})+(?!\d))/g, " ").substr(0,5)+commodityCode.toString().substr(4,10).replace(/\B(?=(\d{2})+(?!\d))/g, " ");
            } else if (commodityCode.length === 8) {
                return isNaN(commodityCode)?"":commodityCode.toString().replace(/\B(?=(\d{4})+(?!\d))/g, " ").substr(0,3)+commodityCode.toString().substr(3,8).replace(/\B(?=(\d{2})+(?!\d))/g, " ");
            } else if (commodityCode.length === 6) {
                return isNaN(commodityCode)?"":commodityCode.toString().replace(/\B(?=(\d{4})+(?!\d))/g, " ").substr(0,2)+commodityCode.toString().substr(2,6).replace(/\B(?=(\d{2})+(?!\d))/g, " ");
            } else if (commodityCode.length === 4) {
                return isNaN(commodityCode)?"":commodityCode.toString();
            }
            return commodityCode;
        };
    })
;



// WEBPACK FOOTER //
// ./app/common/filter/commoditycode-filter.js